import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { loadAllUsers, selectUsersState } from '../users/usersSlice';
import { UserAdministrationContainer } from '../../UserAdministrationContainer';
import { paginate } from '../../../util/paginate';
import { userData } from '../../../util/userData';
import { DeleteConfirmationModal } from '../Modals/DeleteConfirmationModal';
import {
  addUser,
  changeActiveStatus,
  exportUserList,
  flipNotifyUser,
  updatePassword,
} from '../lib/http';
import { SearchUserForm } from '../Modals/SearchUserForm';
import { UpdatePasswordModal } from '../Modals/UpdatePasswordModal';
import { UsersList } from '../Modals/UsersList';
import { filterUsers, redirectToUrl } from '../lib/utils';
import { type } from 'os';


export function UsersDashboardComponent() {
  const dispatch = useAppDispatch();
  const allUsers = useAppSelector(selectUsersState);
  const { isLoading, users } = allUsers;
  const dashboardCount = {
    dashboardCount: 0,
    userName: '',
    id: 0,
  }
  const [usersData, setUsersData] = useState(users.values);
  const [projectCount, setProjectCount] = useState(0);
  const [hideActionAlertDashboardCount, setHideActionAlertDashboardCount] = useState(true);
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);
  const [isUpdatePasswordModalOpen, setIsUpdatePasswordModalOpen] = useState(false);
  const [isCurrentProjectChecked, setIsCurrentProjectChecked] = useState(true);
  const [searchNeedle, setSearchNeedle] = useState('');
  const [selectedUser, setSelectedUser] = useState(dashboardCount);

  const filteredUsers = filterUsers(usersData, searchNeedle, isCurrentProjectChecked)
  const paginatedUsers = paginate(filteredUsers, 1, 50)


  useEffect(() => {
    dispatch(loadAllUsers())
  }, [])

  useEffect(() => {
    setUsersData(users.values)
    setProjectCount(users.projectCount)
    if (users.projectCount > 1) {
      setHideActionAlertDashboardCount(false)
    }
  }, [users.values])


  function notifyUserToggle(userId) {
    let notification = false
    const newUsersData = usersData.map(user => {
      if (user.id === userId) {
        notification = !user.notificationOn;
        return { ...user, notificationOn: notification }
      }
      return user
    })
    setUsersData(newUsersData)

    flipNotifyUser(userId, notification).then(success => {
      if (success)
        setUsersData(newUsersData)
    })
  }

  function popupDeleteUserModal(user) {
    setSelectedUser(user)
    setIsDeleteConfirmationModalOpen(true)

  }

  function openUpdatePasswordModal(user) {
    setSelectedUser(user)
    setIsUpdatePasswordModalOpen(true)
  }

  function dismissModal(modalName: 'deleteUser' | 'updatePassword') {
    switch (modalName) {
      case 'deleteUser':
        setIsDeleteConfirmationModalOpen(false)
        break
      case 'updatePassword':
        setIsUpdatePasswordModalOpen(false)
    }
  }

  function inactivateUser(userId: number) {

    let users = usersData.filter(user => user.id !== userId)
    changeActiveStatus(userId).then(success => {
      if (success)
        setUsersData(users)
      setIsDeleteConfirmationModalOpen(false)
    })
  }

  function updateUserPassword(userId, password) {
    updatePassword(userId, password).then(success => {
      if (success)
        setIsUpdatePasswordModalOpen(false)
    })
  }

  function editUser(userId: number) {
    // @ts-ignore
    userData.storeUserDataInSession('edit_user_id', userId)
    redirectToUrl('user_manage');
  }

  function handleSearch(needle: string) {
    setSearchNeedle(needle);
  }

  function handleCheckboxToggle() {
    setIsCurrentProjectChecked(!isCurrentProjectChecked)
  }

  return (
    <div>
      <div className="row">
        <div className="col s12 m6">
          <h3>User Administration</h3>
        </div>
        <div className="col s12 m6 right-align">
          <a className="btn btn-primary lighten-2"
            onClick={() => { addUser() }}
            style={{ margin: "1.46rem 4px 1.168rem 0", fontSize: "14px" }}
          >
            <i style={{ verticalAlign: "middle", paddingBottom: "5px", fontSize: "18px" }} className="material-icons">add</i>
            Add User
          </a>
          <a className="btn btn-primary lighten-2"
            // id="exportButton"
            onClick={() => { exportUserList() }}
            style={{ margin: "1.46rem 0 1.168rem 0", fontSize: "14px" }}
          >
            <i style={{ verticalAlign: "middle", paddingBottom: "3px", fontSize: "18px" }} className="material-icons">file_download</i>
            Export Users
          </a>
        </div>
      </div>

      <SearchUserForm
        onUsernameNeedleChange={(needle) => { handleSearch(needle) }}
        onCheckboxToggle={() => { handleCheckboxToggle() }}
        isCurrentProjectChecked={isCurrentProjectChecked}
        needle={searchNeedle}
      />
      <UsersList
        isLoading={isLoading}
        hideActionAlertDashboardCount={hideActionAlertDashboardCount}
        users={filteredUsers}
        flipNotifyUser={(userId) => {
          notifyUserToggle(userId);
        }}
        editUser={(userId) => {
          editUser(userId);
        }}
        popupDeleteUserModal={(user) => {
          popupDeleteUserModal(user);
        }}
        openUpdatePasswordModal={(user) => {
          openUpdatePasswordModal(user);
        }}
      />
      <DeleteConfirmationModal
        selectedUser={selectedUser}
        isOpen={isDeleteConfirmationModalOpen}
        dismissDeleteUserModal={() => {
          dismissModal("deleteUser");
        }}
        inactivateUser={(userId) => {
          inactivateUser(userId);
        }}
      />
      <UpdatePasswordModal
        dismissModal={() => {
          dismissModal("updatePassword");
        }}
        updatePassword={(password) => {
          updateUserPassword(selectedUser.id, password);
        }}
        isOpen={isUpdatePasswordModalOpen}
      />

    </div>
  )
}


